import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { v4 as uuid } from "uuid";
import axiosinstances from "../../../Helper/useAxios";
import Select from "react-select";

export default function DmtSupplierConfiguration() {
  const supplierCodes = process.env.REACT_APP_SUPPLIER;

  const navigate = useNavigate();
  const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
  const newId = id;
  // const uuid() = uuid();
  const [selectedOperator, setSelectedOperatior] = useState([]);
  
  const [permissionOption, setPermissionOption] = useState([]);
  const [axiosInstance] = axiosinstances();
  const [profileDetails, setProfileDetails] = useState();
  const profileId = useParams();
  const [tcpUrls, setTcpUrls] = useState({});
  const [isupdateRouting, setIsupdateRouting] = useState(false);
  const [dmtDetails, setDmtDetails] = useState({
    id: "",
    name: "",
    url: "",
    payoutUrl: "",
    operatorMapping: {},
  });

  const [selectedOpretaion, setSelectedOperation] = useState("");
  const [supplierDetails, setSupplierDetails] = useState({});
  const [operatorMendetory, setOperatorMendetory] = useState({
    operator_code: "",
    serviceCode: "",
    categoryCode: "",
  });
  const [operatorOption, setOperatorOption] = useState(["New"]);
  const [supplierId, setSupplierId] = useState("");
//console.log('permissionOption', permissionOption)
  useEffect(() => {
    if (Object.keys(dmtDetails.operatorMapping).length > 0) {
      let values = Object.keys(dmtDetails.operatorMapping);
      const operationNewOpt = ["New", ...values];
      const unique = (value, index, self) => {
        return self.indexOf(value) === index;
      };
      const uniquevalues = operationNewOpt.filter(unique);   
      const uniques = uniquevalues.filter(val => val !== 'New').map(data=>({ value: data, label: data }))
      setPermissionOption(uniques)
      setSelectedOperatior(uniques)
      setOperatorOption(uniquevalues);
    } else if (Object.keys(dmtDetails.operatorMapping).length == 0) {
      setOperatorOption(["New"]);
    }
  }, [dmtDetails.operatorMapping]);

  const token = JSON.parse(sessionStorage.getItem("token"));
  const profileDetailsPage = () => {
    navigate(`/dmt-supplier-config-list`);
  };

  const handleChange = (e) => {
    let { value, name } = e.target;
    if (value == "true") {
      value = true;
    } else if (value === "false") {
      value = false;
    }

    setDmtDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const configDmt = async (roId) => {
    const url = `/api/v1/dmt/supplier-config/admin/create`;
    const response = await axiosInstance
      .post(
        url,
        {
          ...dmtDetails,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "client-id": id,
            role: "ROLE_RETAILER_FINXPAY",
          },
        }
      )
      .then((res) => {
        //console.log("created res-->", res);
        if (res.status == 200) {
          profileDetailsPage();
        }
      })
      .catch((err) => {
        //console.log(err);
      });

    if (response) {
      const result = response.data.orders;

      if (result) {
      }

      return response.data;
    }
    return false;
  };
  const addNewOperatorKey = () => {
    let temp = { ...supplierDetails };
    let newTemp = temp[supplierId];
    newTemp[""] = "";
    setSupplierDetails(temp);
  };
 
  const deleteNewOperatorKey = (key) => {
    let temp = { ...supplierDetails };
    let newTemp = temp[supplierId];
    
    delete newTemp[key];
    //console.log('temp', temp)
    setSupplierDetails(temp);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    configDmt();
  };
  const supplierHandler = (e, check) => {
    const { name, value } = e.target;
    if (check === "supplierId") {
      let supplier = {};
      if (Object.keys(supplierDetails).length > 0) {
        let tempval = supplierDetails[supplierId];
        supplier[value] = tempval;
        setSupplierDetails(supplier);
        setSupplierId(value);
      } else {
        supplier[value] = {
          operator_code: "",
          serviceCode: "",
          categoryCode: "",
        };

        setSupplierDetails(supplier);
        setSupplierId(value);
      }
    } else {
      let temp = { ...supplierDetails };
      let newTemp = temp[supplierId];
      newTemp[check] = value;
      setSupplierDetails(temp);
    }
  };
  const supplierKeyHandler = (e, check) => {
    const { name, value } = e.target;
    let temp = { ...supplierDetails };
    let newTemp = temp[supplierId];
    temp[supplierId][value] = temp[supplierId][check];
    delete newTemp[check];
    setSupplierDetails(temp);
  };
  //console.log("supplierDetails", supplierDetails);
  const checkDeisable = (check) => {
    let disable = false;
    if (
      check === "operator_code" ||
      check === "serviceCode" ||
      check === "categoryCode"
    ) {
      disable = true;
    }

    return disable;
  };
  const saveData = () => {
    setDmtDetails((prev) => {
      return {
        ...prev,
        operatorMapping: { ...prev.operatorMapping, ...supplierDetails },
      };
    });
    setSupplierId("");
    setSupplierDetails({});
    setSelectedOperation("");
  };
  const operationHandler = (e) => {
    const { value } = e.target;
    setSelectedOperation(value);
    if (value !== "New") {
      const newValues = dmtDetails.operatorMapping[value];
      // //console.log('newValues', newValues)
      setSupplierId(value);
      const temp = { ...supplierDetails };
      temp[value] = newValues;
      //console.log("newwtemp", temp);
      setSupplierDetails(temp);
    } else if (value == "New") {
      setSupplierId("");
      setSupplierDetails({});
    }
  };
  const deletOperator = () => {
    let tempData = { ...dmtDetails.operatorMapping };
    delete tempData[supplierId];
    //console.log("tempData", tempData);
    setDmtDetails((prev) => ({ ...prev, operatorMapping: tempData }));
    setSupplierId("");
    setSupplierDetails({});
    setSelectedOperation("");
  };
  const stylesofStype = {
    //container

    control: (styles) => ({
      ...styles,
      backgroundColor: "none",
      borderColor: "none",
      border: "none",
      padding: "0px",
      borderRadius: "0px",
      minHeight: "16px",
      boxShadow: "none",
      fontSize: "16px",
      // border: state.isFocused && "none"
    }),
    valueContainer: (styles) => ({
      ...styles,
      backgroundColor: "none",
      border: "none",
      padding: "0px",
      borderRadius: "0px",
    }),
    multiValue: (styles) => ({ ...styles, lineHeight: "16px" }),
    //IndicatorsContainer
    input: (styles) => ({ ...styles, padding: "0px", margin: "0px" }),
    //singleValue
    singleValue: (styles) => ({ ...styles, fontSize: "14px" }),
  };
  const changeHandler = (select) => {
    //console.log("select", select);
    setSelectedOperatior(select);
  };
const disableHandle = () =>{
  let disable = true;
  if(dmtDetails?.id !== '' && dmtDetails?.name !== '' && dmtDetails?.payoutUrl !== '' && dmtDetails?.url !== ''){
    disable = false
  }

  return disable
}
  return (
    <div class="mid-contant">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="head">
              <h2>Dmt Supplier Config.</h2>
            </div>
          </div>

          <div class="col-12">
            <div class="registerbox">
              <div class="row mb-3">
                <div class="col-12 col-lg-7">
                  <form onSubmit={handleSubmit}>
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <div class="form-floating">
                          <input
                            type="text"
                            class="form-control"
                            id="id"
                            placeholder="Enter Id"
                            name="id"
                            onChange={handleChange}
                            value={dmtDetails.id}
                          />
                          <label for="id">ID</label>
                          {/* {personalDetails.personalInfo.lname.length > 2 && isLnameCorrect &&	<small style={{color:'red'}} >Enter Valid Last Name</small>} */}
                        </div>
                      </div>

                      <div class="col-12 col-md-6">
                        <div class="form-floating">
                          <input
                            type="text"
                            class="form-control"
                            id="name"
                            placeholder="Enter Name"
                            name="name"
                            onChange={handleChange}
                            value={dmtDetails.name}
                          />
                          <label for="name">Name</label>

                          {/* {personalDetails.personalInfo.mobile.length > 1 && isMobileCorrect &&	<small style={{color:'red'}} >Enter Valid Mobile Number</small>} */}
                        </div>
                      </div>

                      <div class="col-12 col-md-6">
                        <div class="form-floating">
                          <input
                            type="text"
                            class="form-control"
                            id="url"
                            placeholder="Enter url"
                            name="url"
                            onChange={handleChange}
                            value={dmtDetails.url}
                          />
                          <label for="url">url</label>
                          {/* { personalDetails.personalInfo.email.length > 3 && isEmailCorrect &&	<small style={{color:'red'}} >Enter Valid Email id</small>} */}
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-floating">
                          <input
                            type="text"
                            class="form-control"
                            id="payoutUrl"
                            placeholder="Enter Operator Code Key"
                            name="payoutUrl"
                            onChange={handleChange}
                            value={dmtDetails.payoutUrl}
                          />
                          <label for="payoutUrl">Payout Url</label>
                          {/* { personalDetails.personalInfo.email.length > 3 && isEmailCorrect &&	<small style={{color:'red'}} >Enter Valid Email id</small>} */}
                        </div>
                      </div>
                      { selectedOperator.length > 0 &&
                        <div className="col-12 col-md-12">
                          
                          <div class="form-floating">
                            <div className="formselect">
                              <label>Selected Operator</label>
                              <Select
                                className="basic-multi-select"
                                styles={stylesofStype}
                                closeMenuOnSelect={false}
                                components={{
                                  IndicatorsContainer: () => null,
                                  IndicatorSeparator: () => null,
                                }}
                                isMulti
                                options={permissionOption}
                                onChange={changeHandler}
                                value={selectedOperator}
                                placeholder=" select multiple option"
                              />
                            </div>
                            </div>
                         
                        </div>
                      }
                      <div class="col-12 col-md-12">
                        <div class="form-floating">
                          <select
                            class="form-select"
                            id="newopr"
                            name="Add New Operator"
                            onChange={operationHandler}
                            value={selectedOpretaion}
                          >
                            <option value="">Select</option>
                            {Array.isArray(operatorOption) &&
                              operatorOption.length > 0 &&
                              operatorOption.map((opt, index) => {
                                return <option value={opt}>{opt}</option>;
                              })}
                          </select>
                          <label for="newopr">Add New Operator</label>
                        </div>
                      </div>
                      {selectedOpretaion !== "" ? (
                        <React.Fragment>
                          <div class="col-12 col-md-12">
                            <div class="form-floating">
                              <input
                                type="text"
                                disabled={selectedOpretaion !== "New"}
                                class="form-control"
                                id="supplierId"
                                placeholder="Enter Supplier Id"
                                onChange={(e) =>
                                  supplierHandler(e, "supplierId")
                                }
                                value={supplierId}
                              />
                              <label for="supplierId">Supplier Id</label>
                            </div>
                          </div>

                          {supplierId !== "" &&
                            Object.keys(supplierDetails).length > 0 &&
                            Object.keys(supplierDetails[supplierId]).map(
                              (key, index) => {
                                return (
                                  <React.Fragment key={index}>
                                    <div class="col-12 col-md-5">
                                      <div class="form-floating">
                                        <input
                                          type="text"
                                          class="form-control"
                                          id={`${key}_key`}
                                          disabled={checkDeisable(key)}
                                          placeholder={`ENTER ${key.toUpperCase()} KEY`}
                                          value={key}
                                          onChange={(e) =>
                                            supplierKeyHandler(e, key)
                                          }
                                        />
                                        <label
                                          for={`${key}_key`}
                                        >{`${key.toUpperCase()} KEY`}</label>
                                      </div>
                                    </div>
                                    <div class="col-12 col-md-5">
                                      <div class="form-floating">
                                        <input
                                          type="text"
                                          class="form-control"
                                          id={`${key}_value`}
                                          placeholder={`ENTER ${key.toUpperCase()} VALUE`}
                                          onChange={(e) =>
                                            supplierHandler(e, key)
                                          }
                                          value={
                                            supplierDetails[supplierId][key]
                                          }
                                        />
                                        <label
                                          for={`${key}_value`}
                                        >{`${key.toUpperCase()} VALUE`}</label>
                                      </div>
                                    </div>
                                    {index > 1 && (
                                      <div class="col-12 col-md-1">
                                        <div class="form-floating">
                                          <button
                                            type="button"
                                            class="btn btn-outline-success"
                                            onClick={addNewOperatorKey}
                                          >
                                            Add
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                    {index > 2 && (
                                      <div class="col-12 col-md-1">
                                        <div class="form-floating">
                                          <button
                                            type="button"
                                            class="btn btn-outline-danger ml-1"
                                            onClick={()=>deleteNewOperatorKey(key)}
                                          >
                                            Delete
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </React.Fragment>
                                );
                              }
                            )}
                        </React.Fragment>
                      ) : (
                        ""
                      )}

                      {
                        <div >
                          {selectedOpretaion !== "" && (
                            <button
                              class="btn btn-success btn-sm mr-1"
                              type="button"
                              id="txnsrch"
                              onClick={saveData}
                            >
                              Save
                            </button>
                          )}
                          {selectedOpretaion !== "New" &&
                            selectedOpretaion !== "" && (
                              <button
                                class="btn btn-danger btn-sm"
                                type="button"
                                onClick={deletOperator}
                              >
                                Delete
                              </button>
                            )}
                        </div>
                      }

                      <div class="col-12">
                        <button type="submit" class="btn btn-primary" id="" disabled={disableHandle()} >
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>

                <div class="col-12 col-lg-5 d-none d-lg-block">
                  <div class="rightbanner">
                    <img
                      src={require("../../../assests/images/register.png")}
                      alt="Oxigen"
                      class="img-fluid"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
